<template>
	<div  class="pt-0 pt-lg-5">
		<a class="anchor" id="references"></a>
		<div class="container pt-3">
			<div class="row pt-5">
				<div class="col-12 col-lg-8 offset-lg-2 pt-5 pb-3 pb-lg-5 zi10">
					<div class="references">
						<carousel :perPage="1" :autoplay="true" :autoplayTimeout="4500" :loop="true" paginationColor="#ffffff" :navigationEnabled="true" @page-change="pageChange" ref="carousel">
							<slide v-for="recipient in recipients" :key="recipient.id">
								<p class="fz-30 fw-500">
									{{ recipient.content }}
								</p>
								<h6 class="mt-4">
									{{ recipient.author }}
								</h6>
							</slide>
						</carousel>
					</div>
				</div>
				<div class="col-12 col-lg-2 d-flex align-items-start justify-content-start justify-content-lg-end">
					<div class="numbers">
						<div class="current">1</div>
						<div class="count">{{ recipients.length }}</div>
					</div>					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Carousel, Slide } from 'vue-carousel';
	export default {
		data() {
			return {
				recipients: [
					{
						content: 'ANGO co roku wykonuje przeglądy mojego pieca. Firma jest bardzo rzetelna. W ubiegłym roku miałem awarię po przepięciu elektrycznym. Naprawili błyskawicznie mimo że było sobotnie popołudnie. Polecam za fachową i szybką obsługę.',
						author: 'Władysław Kujawski'
					},
					{
						content: 'Dziękuję za błyskawiczną wymianę mojego starego kotła. Nowy Vaillant spisuje się doskonale. Temperatura w domu stabilna, rachunki niższe. W lipcu zamówię przegląd.',
						author: 'Bogusław Kopczyński'
					},
					{
						content: 'Polecam usługi Panów Markowskich. Bardzo szybki i dobry kontakt przez ich biuro, naprawa skuteczna i mimo późnej pory dokonali pełnego przeglądu kotła. Pełen profesjonalizm, a wrażenie robi ich świetnie wyposażony w części i narzędzia jeżdżący warsztat. Życzę dalszych sukcesów.',
						author: 'Roman Timofiejuk'
					},
					{
						content: 'Poprzedni fachowiec prawie dwa tygodnie próbował, miał ciągle jakiś problem z częściami a kocioł ciągle nie działał. Panowie z firmy ANGO naprawili go od ręki mając wszystkie potrzebne części.',
						author: 'Tomasz Śnieżek'
					},
					{
						content: 'Naprawa urządzenia przebiegła bez problemów. Kontakt i obsługa na najwyższym poziomie tak samo jak naprawa. Panowie uwinęli się bardzo sprawnie, nie musiałem czekać na sprowadzenie części ponieważ wszystkie mieli na miejscu. Z czystym sumieniem mogę polecić usługi ANGO.',
						author: 'Jerzy Kubarski'
					},
				]
			}
		},
		components: {
			Carousel,
			Slide
		},
		methods: {
			pageChange() {
				let current = this.$refs.carousel ? this.$refs.carousel.currentPage + 1 : 0;				
				document.querySelector('.current').innerHTML = current;
			}
		}
	}
</script>

<style lang="scss"> 
@mixin firefox-only {
  @at-root {
    @-moz-document url-prefix() {
      & {
        @content;
      }
    }
  }
}
.references{
	position: relative;
	&:before{
		content: '';
		position: absolute;
		background-image: url('../assets/images/quote.svg');
		background-position: center;
		background-size: contain; 
		left: -150px;
		width: 97px;
		height: 73px;
	}
}
.VueCarousel-pagination[data-v-438fd353]{
	position: absolute;
	top: -50px;
}
.VueCarousel-dot-container[data-v-438fd353]{
	margin-top: 0 !important;
}
.VueCarousel-dot[data-v-438fd353]{
	position: relative;
	box-sizing: border-box;
	width: 20px !important;
	height: 20px !important;
	margin: 0 !important;
	background-color: white !important; 
	&:before{
		content: '';
		width: 9px;
		height: 9px;
		border: 1px solid black;
		top: 50%;
		left: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
	}
	&.VueCarousel-dot--active:before{
		background-color: black;
	}
}
.VueCarousel-navigation{
	position: relative;
	padding-bottom: 60px;
	@include media-breakpoint-up(lg){
		padding-bottom: 0;
		transform: translateX(20%);
	}
}
.VueCarousel-navigation-button[data-v-453ad8cd]{
	font-size: 0;
	border: 1px solid black !important; 
	padding: 28px !important;
	right: 0;
	left: auto;
	&:before{
		content: '';
		position: absolute;
		width: 13px;
		height: 13px;
		border-left: 2px solid black;
		border-bottom: 2px solid black;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(45deg);
	}
	&:hover{
		@include media-breakpoint-up(md){
			background: linear-gradient(150.05deg, #E42313 0%, #EA5B0C 100%);
		}
	}
}
.VueCarousel-navigation-next[data-v-453ad8cd]{
	border-left: 0 !important;	
	right: 60px !important;
	top: 50% !important;
	transform: translateY(-50%) translateX(100%) !important;
	@include media-breakpoint-up(lg){
		right: 0 !important;
	}
	&:before{
		transform: translate(-50%, -50%) rotate(225deg);
	}
}
.VueCarousel-navigation-prev[data-v-453ad8cd]{
	left: auto !important;
	border-right: 0 !important;
	margin-right: 0 !important;
	@include media-breakpoint-up(lg){
		margin-right: -58px !important;
	}
}
.VueCarousel-navigation--disabled[data-v-453ad8cd]{
	opacity: 1;
}
.numbers{
	display: flex;
	align-items: stretch;
	font-size: 24px;
	font-weight: 600;
	line-height: 1;
	transform: translateY(-72px);
	@include media-breakpoint-up(lg){
		transform: initial !important;
	}
	.current{
		padding-right: 20px;
	}
	.count{
		padding-left: 20px;
		padding-top: 20px;
		border-left: 1px solid black;
	}
}
.zi10{
	z-index: 10;
}
</style>